// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import OrderFilter from './OrderFilter';
import PaginationCount from '../../../Listings/UsedVehicles/Classic/PaginationCount';

class FilterFooter extends Component {
  render() {
    const { customClasses, defaultSort } = this.props;

    return (
      <div className={`filter-v2__footer ${customClasses}`}>
        <PaginationCount />
        <OrderFilter defaultSort={defaultSort} />
      </div>
    );
  }
}

FilterFooter.defaultProps = {
  customClasses: '',
  defaultSort: null,
};

FilterFooter.propTypes = {
  customClasses: PropTypes.string,
  defaultSort: PropTypes.string,
};

export default FilterFooter;
